"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Operator = void 0;
const with_class_name_1 = require("./with-class-name");
const changeCase = __importStar(require("change-case"));
const _ = __importStar(require("lodash"));
class Operator extends with_class_name_1.WithClassName {
    constructor() {
        super(...arguments);
        this.operatorType = 'string';
        this.name = '';
    }
    get readableName() {
        return changeCase.sentenceCase(this.name) || this.name;
    }
    static getOp(operatorType, name) {
        return _.find(Operator.allOperators, (o) => o.operatorType === operatorType && o.name === name);
    }
    static getOperator(operatorType, name) {
        let operator = new Operator();
        operator.operatorType = operatorType;
        operator.name = name;
        return operator;
    }
    static getNumberOperators(operatorType) {
        return [Operator.getOperator(operatorType, '>'),
            Operator.getOperator(operatorType, '>='),
            Operator.getOperator(operatorType, '<'),
            Operator.getOperator(operatorType, '<=')];
    }
}
exports.Operator = Operator;
Operator.allOperators = [
    ...Operator.getNumberOperators('number'),
    Operator.getOperator('string', 'matches'),
    Operator.getOperator('string', 'contains'),
    Operator.getOperator('string', 'endsWith'),
    Operator.getOperator('string', 'iRegexIn'),
    Operator.getOperator('date', 'before'),
    Operator.getOperator('date', 'inLast'),
    Operator.getOperator('date', 'comingUpInNext')
];



//////////////////
// WEBPACK FOOTER
// ./~/rules-config/lib/operator.js
// module id = 1254
// module chunks = 0